<template>
  <div
    class="
            c-filters-cont
            d-flex
            flex-wrap
            align-items-center
            justify-content-between
        "
  >
    <div class="c-filters">
      <div class="c-filter-dialog">
        <v-chip
          :color="searchDate != '' ? 'primary' : 'dark'"
          :text-color="searchDate != '' ? 'light' : 'dark'"
          :outlined="searchDate != '' ? false : true"
          filter
          @click="toggle('date')"
          >{{ trans('Date') }}</v-chip
        >
        <div v-show="date" class="c-filter-location-dialog col-md-4">
          <div class="c-filter-dialog-title">
            {{ trans('Filter by Date') }}
          </div>
          <div class="c-filter-day row p-2">
            <div class="c-filter-day-in col-6 p-2">
              <div
                class="c-filter-day-title"
                @click="dateSearch('today'), $event.target.classList.toggle('c-filter-day-title-active')"
                v-ripple
              >
                {{ trans('Today') }}<span>{{ todaydate }}</span>
              </div>
            </div>
            <div class="c-filter-day-in col-6 p-2">
              <div
                class="c-filter-day-title"
                @click="dateSearch('tomorrow'), $event.target.classList.toggle('c-filter-day-title-active')"
                v-ripple
              >
                {{ trans('Tomorrow') }}<span>{{ tomorrowdate }}</span>
              </div>
            </div>
            <div class="c-filter-day-in col-6 p-2">
              <div
                class="c-filter-day-title"
                @click="dateSearch('weekend'), $event.target.classList.toggle('c-filter-day-title-active')"
                v-ripple
              >
                {{ trans('This Weekend') }}<span>{{ weekenddate }}</span>
              </div>
            </div>
            <data-picker lang="en"></data-picker>
          </div>
          <v-divider></v-divider>
          <v-btn color="primary" class="float-right" @click="date = !date">{{ trans('Done') }}</v-btn>
          <v-btn color="primary" text class="float-left" @click="clearDate">{{ trans('Clear') }}</v-btn>
        </div>
      </div>

      <div class="c-filter-dialog">
        <v-chip
          :color="districtsSelect.length > 0 || citesSelect.length > 0 ? 'primary' : 'dark'"
          :text-color="districtsSelect.length > 0 || citesSelect.length > 0 ? 'light' : 'dark'"
          :outlined="districtsSelect.length > 0 || citesSelect.length > 0 ? false : true"
          filter
          link
          @click="toggle('location')"
          >{{ trans('Location') }}</v-chip
        >
        <div v-show="location" class="c-filter-location-dialog col-md-4">
          <div class="c-filter-dialog-title">
            {{ trans('Filter by city and district') }}
          </div>

          <multi-selector
            v-model="citesSelect"
            :items="cites"
            :label="trans('City')"
            @update="selectSearch('city', $event)"
          ></multi-selector>
          <multi-selector
            v-show="this.citesSelect.length"
            v-model="districtsSelect"
            :items="this.citesSelect.length ? this.districts.filter(district => this.citesSelect.includes(district.city_id)) : []"
            :label="trans('District')"
            @update="selectSearch('district', $event)"
            class="my-2"
          ></multi-selector>
          <v-divider></v-divider>
          <v-btn color="primary" class="float-right" @click="location = !location">{{ trans('Done') }}</v-btn>
          <v-btn color="primary" text class="float-left" @click="clearLocation">{{ trans('Clear') }}</v-btn>
        </div>
      </div>

      <div class="c-filter-dialog">
        <v-chip
          :color="ageSelect.length > 0 ? 'primary' : 'dark'"
          :text-color="ageSelect.length > 0 ? 'light' : 'dark'"
          :outlined="ageSelect.length > 0 ? false : true"
          filter
          @click="toggle('age')"
          >{{ trans('Age') }}</v-chip
        >
        <div v-show="age" class="c-filter-location-dialog col-md-4">
          <div class="c-filter-dialog-title">
            {{ trans('Filter by age') }}
          </div>
          <div class="c-filter-age-cont overflow-hidden">
            <div
              class="c-filter-age-in"
              @click="ageSearch(1), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              1
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(2), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              2
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(3), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              3
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(4), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              4
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(5), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              5
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(6), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              6
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(7), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              7
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(8), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              8
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(9), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              9
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(10), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              10
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(11), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              11
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(12), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              12
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(13), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              13
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(14), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              14
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(15), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              15
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(16), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              16
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(17), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              17
            </div>
            <div
              class="c-filter-age-in"
              @click="ageSearch(18), $event.target.classList.toggle('c-filter-age-in-active')"
              v-ripple
            >
              18+
            </div>
          </div>
          <v-divider></v-divider>
          <v-btn color="primary" class="float-right" @click="age = !age">{{ trans('Done') }}</v-btn>
          <v-btn color="primary" text class="float-left" @click="clearAge">{{ trans('Clear') }}</v-btn>
        </div>
      </div>

      <div class="c-filter-dialog">
        <v-chip
          :color="timeSelect.length > 0 ? 'primary' : 'dark'"
          :text-color="timeSelect.length > 0 ? 'light' : 'dark'"
          :outlined="timeSelect.length > 0 ? false : true"
          filter
          @click="toggle('time')"
          >{{ trans('Time') }}</v-chip
        >
        <div v-show="time" class="c-filter-location-dialog col-md-4">
          <div class="c-filter-dialog-title">
            {{ trans('Filter by time') }}
          </div>

          <multi-selector
            v-model="timeSelect"
            :items="times"
            :label="trans('Time')"
            @update="selectSearch('time', $event)"
          ></multi-selector>
          <v-divider></v-divider>
          <v-btn color="primary" class="float-right" @click="time = !time">{{ trans('Done') }}</v-btn>
          <v-btn color="primary" text class="float-left" @click="clearTime">{{ trans('Clear') }}</v-btn>
        </div>
      </div>

      <div class="c-filter-dialog">
        <v-chip
          :color="categorySelect.length > 0 ? 'primary' : 'dark'"
          :text-color="categorySelect.length > 0 ? 'light' : 'dark'"
          :outlined="categorySelect.length > 0 ? false : true"
          filter
          @click="toggle('category')"
          >{{ trans('Category') }}</v-chip
        >

        <div v-show="category" class="c-filter-location-dialog col-md-4">
          <div class="c-filter-dialog-title">
            {{ trans('Filter by category') }}
          </div>
          <multi-selector
            v-model="categorySelect"
            :items="categories"
            :label="trans('Category')"
            @update="selectSearch('category', $event)"
          ></multi-selector>
          <v-divider></v-divider>
          <v-btn color="primary" class="float-right" @click="category = !category">{{ trans('Done') }}</v-btn>
          <v-btn color="primary" text class="float-left" @click="clearCategory">{{ trans('Clear') }}</v-btn>
        </div>
      </div>
    </div>
    
    <search-box />
    <sort-box />
  </div>
</template>

<script>
import MultiSelector from '../../../../../../../resources/js/components/FormFields/MultiSelector.vue'
import SearchBox from './SearchBox.vue'
import SortBox from './SortBox.vue'
export default {
  components: { MultiSelector, SearchBox, SortBox },
  props: ['cites', 'districts', 'times', 'categories', 'todaydate', 'tomorrowdate', 'weekenddate', 'saved'],
  data() {
    return {
      location: false,
      age: false,
      time: false,
      category: false,
      date: false,
      dateSelect: [],
      ageSelect: [],
      categorySelect: [],
      timeSelect: [],
      citesSelect: [],
      districtsSelect: [],
    }
  },
  methods: {
    toggle(target) {
      target != 'location' ? (this.location = false) : (this.location = !this.location)
      target != 'age' ? (this.age = false) : (this.age = !this.age)
      target != 'time' ? (this.time = false) : (this.time = !this.time)
      target != 'category' ? (this.category = false) : (this.category = !this.category)
      target != 'date' ? (this.date = false) : (this.date = !this.date)
    },
    close(e) {
      //console.log(e.target);
      if (
        (!this.$el.contains(e.target) &&
          !e.target.classList.contains('v-list-item__title') &&
          !e.target.classList.contains('v-list-item__content') &&
          !e.target.classList.contains('v-list-item')) ||
        e.target.classList.contains('c-filters') ||
        e.target.classList.contains('c-filters-cont')
      ) {
        this.location = false
        this.age = false
        this.time = false
        this.category = false
        this.date = false
      }
    },
    clearLocation() {
      this.citesSelect = []
      this.districtsSelect = []
      this.$parent.$root.citySearch([])
      this.$parent.$root.districtSearch([])
    },
    clearAge() {
      var el = this.$el.querySelectorAll('.c-filter-age-in')
      el.forEach((value, index) => {
        this.$el.querySelectorAll('.c-filter-age-in')[index].classList.remove('c-filter-age-in-active')
      })
      this.ageSelect = []
      this.$parent.$root.clearAgeSearch()
    },
    clearTime() {
      this.$parent.$root.timeSearch([])
      this.timeSelect = []
    },
    clearCategory() {
      this.$parent.$root.categorySearch([])
      console.log(this.categorySelect)
      this.categorySelect = []
    },
    ageSearch(age) {
      if (this.ageSelect.indexOf(age) === -1) {
        this.ageSelect.push(age)
      } else {
        const index = this.ageSelect.indexOf(age)
        if (index > -1) {
          this.ageSelect.splice(index, 1)
        }
      }
      this.$parent.$root.ageSearch(age);
      Fire.$emit('searching');
    },
    dateSearch(date) {
      this.$parent.$root.dateSearch(date)
      this.$parent.$root.removeClasses('c-filter-day-title-active', date)
      this.$parent.$root.searchDate == '' ? (this.dateSelect = []) : (this.dateSelect = [1])
      Fire.$emit('searching');
    },
    clearDate() {
      this.$parent.$root.searchDate = ''
      this.$parent.$root.removeClasses('c-filter-day-title-active', 'custom')
      this.$parent.$root.searchDate == '' ? (this.dateSelect = []) : (this.dateSelect = [1])
      Fire.$emit('searching')
    },
    selectSearch(name, finalData) {
      finalData = finalData.join(',')
      switch (name) {
        case 'time':
          this.$parent.$root.timeSearch(finalData)
          break
        case 'category':
          this.$parent.$root.categorySearch(finalData)
          break
        case 'city':
          this.$parent.$root.citySearch(finalData)
          break
        case 'district':
          this.$parent.$root.districtSearch(finalData)
          break
        default:
          return null
      }
      Fire.$emit('searching');
    },
  },

  mounted() {
    if (this.saved) {
      //update search filters
      this.saved.forEach((value, index) => {
        switch (value.name) {
          case 'date':
            this.dateSelect.push(value.value)
            this.$parent.$root.dateSearch(value.value)
            break
          case 'age':
            this.ageSelect.push(value.value)
            this.$parent.$root.ageSearch(value.value)
            break
          case 'category':
            this.categorySelect.push(value.value)
            this.$parent.$root.categorySearch(value.value)
            break
          case 'time':
            this.timeSelect.push(value.value)
            this.$parent.$root.timeSearch(value.value)
            break
          case 'city':
            this.citesSelect.push(value.value)
            this.$parent.$root.citySearch(value.value)
            break
          case 'district':
            this.districtsSelect.push(value.value)
            this.$parent.$root.searchDistrict = value.value;
            break
          default:
        }
      });
      Fire.$emit('searching');

      document.addEventListener('click', this.close)
    }
  },
  computed: {
    searchDate() {
      return this.$parent.$root.searchDate
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close)
  },
}
</script>

<style scoped>
.c-filter-dialog {
  margin-top: 8px !important;
}
</style>
